import { jsx } from "react/jsx-runtime";
import { RatingInputFieldWUT } from "../../../ui/rating-input-field/rating-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const RatingInputWUT = (props) => {
  const fieldType = FIELD_TYPES.RATING_INPUT;
  return /* @__PURE__ */ jsx(RatingInputFieldWUT, { ...props, fieldType });
};
export {
  RatingInputWUT
};
//# sourceMappingURL=rating-input-wut.js.map
